<template>
  <template v-if="componentLoading">
    <Loading :style="style" />
  </template>
  <view
    v-else
    :class="{
      'pft-list-2': true,
    }"
    :style="pftListComponentStyle"
    :flex="flex"
    ref="ScrollContainer"
  >
    <view v-if="data.length === 0" class="empty-container">暂无数据</view>
    <view v-else :class="`scroll-container ${playStatus}`" :style="containerStyle" @mouseenter="onfocusenter" @mouseleave="onfocusleave">
      <DefaultTheme
        v-if="theme === 'default'"
        :data="data"
        :itemStyle="itemStyle"
        :nameStyle="nameStyle"
        :countStyle="countStyle"
        :rateClass="rateClass"
        :suffix="suffix"
        v-model:scroll="shouldScroll"
        :duration="duration"
        :minHeight="ScrollContainerHeight"
      />
      <CrownTheme
        v-else-if="theme === 'crown'"
        :data="data"
        :itemStyle="itemStyle"
        :nameStyle="nameStyle"
        :countStyle="countStyle"
        :rateClass="rateClass"
        :suffixStyle="suffixStyle"
        :suffix="suffix"
        v-model:scroll="shouldScroll"
        :duration="duration"
        :minHeight="ScrollContainerHeight"
      />
    </view>

    <!-- <view v-else class="list-item" :style="listStyle">
      <template v-for="(item, index) of data" :key="index">
        <template v-if="theme === 'default'">
          <view class="item-index">{{ index + 1 }}</view>
        </template>
        <template v-else-if="theme === 'crown'">
          <template v-if="index < 3">
            <view class="item-index">
              <img :src="icon[`crown${index + 1}`]" />
            </view>
          </template>
          <template v-else>
            <view class="item-index">{{ (index + 1).toString().padStart(2, "0") }}</view>
          </template>
        </template>
        <view class="item-name" :style="nameStyle">{{ item.name }}</view>

        <template v-if="theme === 'default'">
          <view class="item-rate-container" flex="dir:right">
            <view class="item-rate" :style="rateClass(item, index)" />
            <view class="item-count" :style="countStyle">{{ item.count }} {{ suffix }}</view>
          </view>
        </template>
        <template v-else-if="theme === 'crown'">
          <view class="item-progress-container">
            <view class="item-progress" :style="rateClass(item, index)" />
          </view>
          <view class="item-count" :style="countStyle">{{ item.count }}</view>
          <view class="item-suffix" :style="suffixStyle">{{ suffix }}</view>
        </template>
      </template>
    </view> -->
  </view>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted, watch } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import DefaultTheme from "./List2Theme/default.vue"
import CrownTheme from "./List2Theme/crown.vue"

import { cloneDeep } from "lodash-es"
import { removePx } from "@p-v/utils"
const playStatus = ref("running")

const ScrollContainerHeight = ref(undefined)
const ScrollContainer = ref<any>(null)

const onfocusenter = () => {
  playStatus.value = "paused"
}

const onfocusleave = () => {
  playStatus.value = "running"
}
defineOptions({
  name: "List2",
})

interface List1Props {
  style?: { [key: string]: string }
  flex?: string
  suffix: string | undefined
  itemStyle?: { [key: string]: string }
  nameStyle?: { [key: string]: string }
  countStyle?: { [key: string]: string }
  suffixStyle?: { [key: string]: string }
  rateStyle?: { [key: string]: string }
  rateStyles?: { [key: string]: string }[]
  theme?: "default" | "crown"
  scroll?: boolean
  duration?: number
}

interface ListDataItem {
  name: string
  count: number
  percent: number
  rate?: number
}

const componentLoading = ref<boolean>(true)
const data = ref<ListDataItem[]>([])

const props = withDefaults(defineProps<List1Props>(), {
  style: () => ({}),
  flex: () => "dir:top cross:left",
  suffix: undefined,
  itemStyle: () => ({}),
  nameStyle: () => ({}),
  countStyle: () => ({}),
  rateStyle: () => ({}),
  theme: () => "default",
  duration: () => 10,
  scroll: () => true,
})
const shouldScroll = ref(props.scroll)

const containerStyle = computed(() => {
  if (!shouldScroll.value) {
    return {}
  }
  let maxHeight = 32
  if (props.nameStyle.height || props.nameStyle.lineHeight) {
    maxHeight = Math.max(maxHeight, Number(removePx(props.nameStyle.lineHeight || props.nameStyle.height)))
  }
  if (props.countStyle.height || props.countStyle.lineHeight) {
    maxHeight = Math.max(maxHeight, Number(removePx(props.countStyle.lineHeight || props.countStyle.height)))
  }
  if (props.itemStyle?.height || props.itemStyle?.lineHeight) {
    maxHeight = Math.max(maxHeight, Number(removePx(props.itemStyle.lineHeight || props.itemStyle.height)))
  }
  const height = data.value.length * maxHeight
  if (ScrollContainerHeight.value) {
    const pages = Math.ceil(height / ScrollContainerHeight.value)
    return {
      animationDuration: `${props.duration * pages}s`,
    }
  } else {
    return {}
  }
})

const rateClass = (item: ListDataItem, index: number) => {
  const styleTpl = props.rateStyles?.[index] || {}
  return Object.assign(cloneDeep(props.rateStyle), styleTpl, { width: `${item.percent}%` })
}

const loading = () => {
  componentLoading.value = true
}

const setData = (val: ListDataItem[]) => {
  componentLoading.value = false
  data.value = val.map(e => {
    // 技术债，保持和 List1 的传值统一并，对历史已经使用 rate 的项目做兼容
    if (e.rate !== undefined && e.percent === undefined) {
      e.percent = e.rate
    }
    return {
      name: e.name,
      count: e.count,
      percent: e.percent,
      rate: e.rate,
    }
  })
}

const pftListComponentStyle = computed(() => {
  const style: any = {}
  if (!props.scroll) {
    style.overflow = "auto"
  }
  return Object.assign(props.style, style)
})

if (props.scroll) {
  watch(
    () => ScrollContainer.value,
    val => {
      if (val) {
        console.log("ScrollContainer.value", ScrollContainer)
        ScrollContainerHeight.value = ScrollContainer.value?.clientHeight || 0
      }
    },
    { immediate: true },
  )
}

defineExpose({ loading, setData })
</script>
<style lang="scss" scoped>
@keyframes pft_rollup {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -50%, 0);
  }
}
.pft-list-2 {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  // 滚动条美化
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(126, 126, 126, 0);
    border-radius: 1px;
    transition: all 0.3s;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(126, 126, 126, 0.5);
  }

  .scroll-container {
    animation-name: pft_rollup;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-play-state: running; /* 动画默认运行 */
    &.paused {
      animation-play-state: paused;
    }
  }
  .empty-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(163, 166, 173, 0.6431372549);
  }
}
</style>
